import { render, staticRenderFns } from "./EditSelectedDigiBoardTimeSlots.vue?vue&type=template&id=4fc9abe6&scoped=true&"
import script from "./EditSelectedDigiBoardTimeSlots.vue?vue&type=script&lang=js&"
export * from "./EditSelectedDigiBoardTimeSlots.vue?vue&type=script&lang=js&"
import style0 from "./EditSelectedDigiBoardTimeSlots.vue?vue&type=style&index=0&id=4fc9abe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc9abe6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VContainer,VDialog,VForm,VIcon,VSpacer})
